import ModelTypeConstants from 'constants/ModelTypeConstants';
import getNoteLinkedObjectsOfTypes, {
  getNoteLinkedObjectsOfTypesFromNoteParts,
} from 'notebook/notes/util/getNoteLinkedObjectsOfTypes';
import {Note, NotePart} from 'notebook/util/NoteUtilConstants';

import {UnknownStructuredTable} from '../StructuredTableConstants';

export default function getAllStructuredTablesInNote(note: Note): Array<UnknownStructuredTable> {
  return getNoteLinkedObjectsOfTypes(note, [
    ModelTypeConstants.STRUCTURED_TABLE,
  ]) as Array<UnknownStructuredTable>;
}

export function getAllStructuredTablesFromNoteParts(
  noteParts: Array<NotePart>
): Array<UnknownStructuredTable> {
  return getNoteLinkedObjectsOfTypesFromNoteParts(noteParts, [
    ModelTypeConstants.STRUCTURED_TABLE,
  ]) as Array<UnknownStructuredTable>;
}

export function doesNoteIncludeStructuredTableUuid(note: Note, provenanceUuid: string): boolean {
  return getAllStructuredTablesInNote(note)
    .map((structuredTable) => structuredTable.provenanceUuid)
    .includes(provenanceUuid);
}
